interface Props {
  content: React.ReactNode[];
}

export const Hidden = ({ content }: Props) => (
  <>
    <div className="block sm:hidden w-full">{content[0]}</div>
    <div className="hidden sm:block w-full">{content[1]}</div>
  </>
);
